module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodrain-1984559b2e245b2676087e188535f19d.svg";